import { Injectable } from '@angular/core';
import { IRoleDto } from 'core/dto';
import { Observable } from 'rxjs';
import { ApiService } from '../api.service';
import { controllerEndpoints } from '../controller.endpoints';

@Injectable({
  providedIn: 'root'
})
export class RoleRemoteControllerService {

  readonly _endpoint = controllerEndpoints.ROLE;
  constructor(private readonly _apiService: ApiService) {

  }

  getMany(): Observable<IRoleDto[]> {
    return this._apiService.get(this._endpoint);
  }

}
